export const whoWeAre = {
  name: "who we re for",
  image:
    "https://cdn.builder.io/api/v1/image/assets%2Fc1dd4445883e49dcb7e2794dbacad44e%2F7ab19b0e026a4060be90b33a4f7d1a4b",
  title: "Who we’re for",
  subCopy:
    "No matter where you are in your private practice journey, we’re here to help with easy-to-use tools.",
  groupLinks: [
    {
      title: "By practice size",
      links: [
        {
          label: "Solo practices",
          link: "/ehr-for-solo-practice/",
        },
        {
          label: "Group practices",
          link: "/features/group-practice/",
        },
      ],
    },
    {
      title: "By specialty",
      links: [
        {
          label: "Therapists",
          link: "/specialty/ehr-software-for-therapists/",
        },
        {
          label: "Speech-Language Pathologists",
          link: "/specialty/software-for-speech-language-pathologists/",
        },
        {
          label: "Occupational Therapists",
          link: "/specialty/software-for-occupational-therapists/",
        },
        {
          label: "Psychiatrists",
          link: "/specialty/psychiatric-emr/",
        },
        {
          label: "All specialties",
          link: "/specialty/",
        },
      ],
    },
  ],
};

export const features = {
  name: "features",
  image:
    "https://cdn.builder.io/api/v1/image/assets%2Fc1dd4445883e49dcb7e2794dbacad44e%2F844c6285583b477eb5eb80966cbb40fc",
  title: "Features",
  subCopy:
    "From admin work to clinical care, our tools simplify every part of practice management.",
  subGroupLink: [
    {
      label: "Features overview",
      link: "/features/",
    },
    {
      label: "Product demo",
      link: "/demo/",
    },
  ],
  groupLinks: [
    {
      title: "STREAMLINE ADMIN TASKS",
      links: [
        {
          label: "Scheduling",
          link: "/features/scheduling-calendar/",
        },
        {
          label: "Billing & payments",
          link: "/features/credit-card-processing/",
        },
        {
          label: "Insurance",
          link: "/features/insurance/",
        },
        {
          label: "Notes & documentation",
          link: "/features/therapy-notes/",
        },
      ],
    },
    {
      title: "Optimize client care",
      links: [
        {
          label: "Telehealth",
          link: "/features/telehealth/",
        },
        {
          label: "Client Portal",
          link: "/features/client-portal/",
        },
        {
          label: "Measurement-based care",
          link: "/features/measurement-based-care/",
        },
        {
          label: "ePrescribe",
          link: "/features/eprescribe/",
        },
      ],
    },
    {
      title: "Manage & grow your practice",
      links: [
        {
          label: "EHR mobile app",
          link: "/features/mobile-app/",
        },
        {
          label: "Analytics & reports",
          link: "/features/reports/",
        },
        {
          label: "Online appointment requests",
          link: "/features/online-booking/",
        },
      ],
    },
    {
      title: "Privacy & Support",
      links: [
        {
          label: "HIPAA-compliant security",
          link: "/features/security/",
        },
        {
          label: "Support",
          link: "/features/support/",
        },
        {
          label: "Switching to SimplePractice",
          link: "/features/simplify-switching/",
        },
      ],
    },
  ],
};

export const resources = {
  name: "resources",
  image:
    "https://cdn.builder.io/api/v1/image/assets%2Fc1dd4445883e49dcb7e2794dbacad44e%2F9b8f2061eaab4ab9b9ac46423cb50aee",
  title: "Resources",
  subCopy:
    "Whether you’re providing or seeking care, we offer helpful tools and tips.",
  groupLinks: [
    {
      title: "FOR PRACTITIONERS",
      links: [
        {
          label: "Blog",
          link: "/pollen/",
        },
        {
          label: "Resource library",
          link: "/resources/",
        },
        {
          label: "Track Your Hours",
          link: "https://www.trackyourhours.com/",
          icon: true,
        },
      ],
    },
    {
      title: "FOR CLIENTS",
      links: [
        {
          label: "Find a therapist",
          link: "https://meetmonarch.com/",
          icon: true,
        },
        {
          label: "Therapy-seeker resources",
          link: "https://meetmonarch.com/health-resources/",
          icon: true,
        },
      ],
    },
    {
      title: "Product support",
      links: [
        {
          label: "Product tutorials",
          link: "https://support.simplepractice.com/hc/en-us/articles/360058349331-On-demand-Classes-and-Q-As",
          icon: true,
        },
        {
          label: "Help Center",
          link: "https://support.simplepractice.com/hc/en-us",
          icon: true,
        },
        {
          label: "FAQs",
          link: "/features/faqs/",
        },
      ],
    },
  ],
};

export const variantsNavMobile = {
  mainContent: {
    hidden: {
      x: "-110%",
    },
    visible: {
      x: 0,
    },
  },
  secondContent: {
    hidden: {
      x: "100%",
      transition: { duration: 0.1 },
    },
    visible: {
      x: 0,
      transition: { duration: 0 },
    },
  },
};

export const mainLinksNav = [
  {
    label: "Who we’re for",
    value: whoWeAre,
  },
  {
    label: "Features",
    value: features,
  },
  {
    label: "Resources",
    value: resources,
  },
  {
    label: "Pricing",
    value: null,
    extraLink: "/pricing/",
  },
];
